export default "__VITE_ASSET__CXthHNqO__"